<script setup lang="ts">
import type { ApiResponseErrors } from 'ui/util/api/ApiResponse';

defineProps<{
  error: NonNullable<ApiResponseErrors>,
}>();
</script>

<template>
  <UAlert
    title=""
    color="error"
    variant="subtle"
  >
    <template #title>
      <template v-if="'cancel' in error">
        Request cancelled
      </template>
      <template v-else>
        {{ error.error.error_message }}
      </template>
    </template>
  </UAlert>
</template>
